import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=1ff8ca78&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=1ff8ca78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8ca78",
  null
  
)

export default component.exports